import { render, staticRenderFns } from "./UpdatePayment.vue?vue&type=template&id=b388b98a&scoped=true"
import script from "./UpdatePayment.vue?vue&type=script&lang=js"
export * from "./UpdatePayment.vue?vue&type=script&lang=js"
import style0 from "./UpdatePayment.vue?vue&type=style&index=0&id=b388b98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b388b98a",
  null
  
)

export default component.exports